import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import Icon from '../Icon';

var IconClear = /*#__PURE__*/function (_React$Component) {
  _inherits(IconClear, _React$Component);

  var _super = _createSuper(IconClear);

  function IconClear() {
    var _this;

    _classCallCheck(this, IconClear);

    _this = _super.apply(this, arguments);
    _this.state = {
      closeShow: false
    };

    _this.mouseEnter = function () {
      _this.setState({
        closeShow: true
      });
    };

    _this.mouseLeave = function () {
      _this.setState({
        closeShow: false
      });
    };

    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e);
      }
    };

    return _this;
  }

  _createClass(IconClear, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/React.createElement(Icon, {
        className: className || '',
        name: this.state.closeShow ? 'times-circle' : 'calendar',
        onClick: this.handleClick,
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave
      });
    }
  }]);

  return IconClear;
}(React.Component);

export { IconClear as default };